module.exports = __webpack_public_path__ + "media/images/icons/info-91d27a7ba6355a578d87c82cb3f5a86b.svg";